import gql from "graphql-tag";
import { FRAGMENT_EVENT_DETAILS } from "./fragments.js";

export const GET_EVENT = gql`
  ${FRAGMENT_EVENT_DETAILS}
  query GetEvent($uri: ID!) {
    event(id: $uri, idType: URI) {
      ...EventDetailsFragment
    }
  }
`;
